<template>
	<div class="card-header">
		<slot />
	</div>
</template>

<script>
export default {
	name: 'CardHeader',
};
</script>

<style lang="scss" scoped>
.card-header {
	border-bottom: solid 1px #e9e9e9;
	margin-left: -20px;
	margin-right: -20px;
	margin-top: -20px;
}
</style>



// WEBPACK FOOTER //
// src/modules/shared/components/ui/Card/CardHeader.vue